import mitt, { type Emitter } from "mitt";

type Events = {
  "send-report": string;
  "export-csv": void;
  "read-all": void;
};

export const eventBus: Emitter<Events> = mitt();
